import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AdminRoutingModule} from './admin-routing.module';
import {SharedModule} from '../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DialogsComponent } from './containers/dialogs/dialogs.component';
import { DialogsTableComponent } from './components/dialogs/dialogs-table/dialogs-table.component';
import { EditDialogComponent } from './components/dialogs/edit-dialog/edit-dialog.component';
import { DialogsFilterComponent } from './components/dialogs/dialogs-filter/dialogs-filter.component';
import { ErrorMarginsComponent } from './containers/error-margins/error-margins.component';
import { ErrorMarginsTableComponent } from './components/error-margins/error-margins-table/error-margins-table.component';
import { EditErrorComponent } from './components/error-margins/edit-error/edit-error.component';
import { CountriesComponent } from './containers/countries/countries.component';
import { CountriesFilterComponent } from './components/countries/countries-filter/countries-filter.component';
import { CountriesTableComponent } from './components/countries/countries-table/countries-table.component';
import { EditCountryComponent } from './components/countries/edit-country/edit-country.component';
import { CreateCountryComponent } from './components/countries/create-country/create-country.component';
import { WeeeSystemComponent } from './containers/weee-system/weee-system.component';
import { WeeeSystemFilterComponent } from './components/weee-system/weee-system-filter/weee-system-filter.component';
import { WeeeSystemTableComponent } from './components/weee-system/weee-system-table/weee-system-table.component';
import { EditWeeeSystemComponent } from './components/weee-system/edit-weee-system/edit-weee-system.component';
import { CreateWeeeSystemComponent } from './components/weee-system/create-weee-system/create-weee-system.component';
import { UsersComponent } from './containers/users/users.component';
import { UsersFilterComponent } from './components/users/users-filter/users-filter.component';
import { UsersTableComponent } from './components/users/users-table/users-table.component';
import { CreateUsersComponent } from './components/users/create-users/create-users.component';
import { EditUsersComponent } from './components/users/edit-users/edit-users.component';
import { ErrorMarginsFilterComponent } from './components/error-margins/error-margins-filter/error-margins-filter.component';
import { TemplatesFilterComponent } from './components/templates/templates-filter/templates-filter.component';
import { TemplatesTableComponent } from './components/templates/templates-table/templates-table.component';
import { EditTemplateComponent } from './components/templates/edit-template/edit-template.component';
import { TemplatesComponent } from './containers/templates/templates.component';
import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import { ChartLabelsComponent } from './containers/chart-labels/chart-labels.component';
import {ChartLabelsEditDialogComponent} from './components/chart-labels/chart-labels-edit-dialog/chart-labels-edit-dialog.component';
import {ChartLabelsTableComponent} from './components/chart-labels/chart-labels-table/chart-labels-table.component';
import {ChartLabelsFilterComponent} from './components/chart-labels/chart-labels-filter/chart-labels-filter.component';
import { UploadPopulationComponent } from './components/countries/upload-population/upload-population.component';
import {NgxMatFileInputModule} from '@angular-material-components/file-input';


@NgModule({
  declarations: [
    DialogsComponent,
    DialogsTableComponent,
    EditDialogComponent,
    DialogsFilterComponent,
    ErrorMarginsComponent,
    ErrorMarginsTableComponent,
    EditErrorComponent,
    CountriesComponent,
    CountriesFilterComponent,
    CountriesTableComponent,
    EditCountryComponent,
    CreateCountryComponent,
    WeeeSystemComponent,
    WeeeSystemFilterComponent,
    WeeeSystemTableComponent,
    EditWeeeSystemComponent,
    CreateWeeeSystemComponent,
    UsersComponent,
    UsersFilterComponent,
    UsersTableComponent,
    CreateUsersComponent,
    EditUsersComponent,
    ErrorMarginsFilterComponent,
    TemplatesFilterComponent,
    TemplatesTableComponent,
    EditTemplateComponent,
    TemplatesComponent,
    ChartLabelsComponent,
    ChartLabelsFilterComponent,
    ChartLabelsTableComponent,
    ChartLabelsEditDialogComponent,
    UploadPopulationComponent,
  ],
    imports: [
        CommonModule,
        AdminRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        CKEditorModule,
        NgxMatFileInputModule
    ]
})
export class AdminModule { }
